// import RepositoryFactory from "@/apis";
// const membership = RepositoryFactory.membership;
import membership from "../../apis/membership";

export default {
  createMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await membership.createMembership(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAllMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await membership.getAllMembership(payload);

        // console.log(data);
        // Update user details
        commit("GET_MEMBERSHIP", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getSingleMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await membership.getSingleMembership(payload);

        // console.log(data);
        // Update user details
        commit("GET_MEMBERSHIP", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateMembershipDetails({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await membership.updateMembership(payload);

        // console.log(data);
        // Update user details

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await membership.deleteMembership(payload);
        // console.log(data);
        // Update user details

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  membershipValidityCheck({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await membership.membershipValidityCheck(payload);
        // Update user details
        // console.log(data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  uniqueMonthCheck({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await membership.uniqueMonthCheck(payload);
        commit("GET_MONTH", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
